/**
 * Module dependencies.
 */

import { useCallback } from 'react';

/**
 * Constants.
 */

const googleTagManagerId = process.env.NEXT_PUBLIC_GTM_ID;

/**
 * Export `useGTMEvent` hook.
 */

export function useGTMEvent() {
  const handleEvent = useCallback((args: Record<string, any>) => {
    if (!googleTagManagerId || !window.dataLayer) {
      return;
    }

    window.dataLayer.push(args);
  }, []);

  return handleEvent;
}
